module.exports = __webpack_public_path__ + "img/05010017.c58b5d2a.jpg";